module.exports = __webpack_public_path__ + "img/share-coupon2.965b32a8.png";